import { ProductTreeActionsItem } from 'src/app/core/models/productTreeActions.model';
import type { Entity } from '../../../core/models/entity.model';

export interface ProjectEntityListState {
  // Query result
  projectEntityList: Entity[];
  count: number;
  rootActions: ProductTreeActionsItem[];
  // Filter and paging (query params)
  searchPhrase: string;
  onlyMine: boolean;
  pageSize: number;
  page: number;
  // Errors and loading
  projectEntityListError: any;
  actionErrorData: any;
  actionError: string;
  projectEntityListLoading: boolean;
}

export const initialState: ProjectEntityListState = {
  projectEntityList: [],
  count: 0,
  rootActions: [],
  searchPhrase: '',
  onlyMine: false,
  pageSize: 10,
  page: 0,
  projectEntityListError: null,
  actionErrorData: null,
  actionError: '',
  projectEntityListLoading: false
};

export const pageSizeOptions = [10, 25, 50];
